export const Logo = ({ light = false, className = "h-11" }) => {
  const img = (
    <img
      src="/ato-logo.png"
      alt="ARORA TRAVEL ONLINE"
      className={`${className} w-auto object-contain`}
    />
  );
  if (light) {
    return (
      <span className="inline-flex rounded-2xl bg-sand px-4 py-2.5">{img}</span>
    );
  }
  return img;
};
